import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { localStorageServices } from 'services/localStorageServices';
import EN from './dictionaries/en.json';
import JP from './dictionaries/jp.json';
import ko from './dictionaries/ko.json';

const resources = {
  en: EN,
  jp: JP,
  ko: ko,
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: localStorageServices.getI18Lng(),
});

export default i18n;
